// src/components/PVForm.jsx
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";
import {
  Box,
  Heading,
  Grid,
  GridItem,
  Input,
  Button,
  VStack,
  Text,
} from "@chakra-ui/react";
import { useColorMode } from "./ui/color-mode";
import KontaktSection from "../sections/KontaktSection";
import WartungSection from "../sections/WartungSection";
import ModuleSection from "../sections/ModuleSection";
import WechselrichterSection from "../sections/WechselrichterSection";
import DatenloggerSection from "../sections/DatenloggerSection";
import MobilfunkRouterSection from "../sections/MobilfunkRouterSection";
import NetzwerkRouterSection from "../sections/NetzwerkRouterSection";
import AufstellungsortSection from "../sections/AufstellungsortSection";
import AngabenZumDachSection from "../sections/AngabenZumDachSection";
import DacheindeckungSection from "../sections/DacheindeckungSection";
import SchienensystemSection from "../sections/SchienensystemSection";
import ModulbefestigungSection from "../sections/ModulbefestigungSection";
import BefestigungSection from "../sections/BefestigungSection";
import BeschwerungSection from "../sections/BeschwerungSection";
import AusrichtungUndNeigungSection from "../sections/AusrichtungUndNeigungSection";
import NeigungDerModuleSection from "../sections/NeigungDerModuleSection";
import ZaehlerSection from "../sections/ZaehlerSection";
import { Flex } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";


const fields = [
  { key: "projektNummer", label: "Projekt-Nr.", required: true },
  { key: "anlagenName", label: "Anlagenname", required: true },
  { key: "anlagenGroesse", label: "Größe (kWp)", required: true },
  { key: "strasse", label: "Straße", required: true },
  { key: "plz", label: "PLZ", required: true },
  { key: "ort", label: "Ort", required: true },
  { key: "latitude", label: "Breitengrad", required: false },
  { key: "longitude", label: "Längengrad", required: false },
];

export default function PVForm({ onNext }) {
  const [formData, setFormData] = useState(() =>
    Object.fromEntries(fields.map((f) => [f.key, ""]))
  );


  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { colorMode } = useColorMode();

  //new
  const [anlageId, setAnlageId] = useState(null);
  const navigate = useNavigate();

  const { id } = useParams(); // new

  const isEditMode = Boolean(id); // new
  // 👉 Add it here
  useEffect(() => {

    if (!formData.projektNummer || id) return; // avoid running too early

    axios.get(`${process.env.REACT_APP_API_URL}/api/anlagen/check/${formData.projektNummer}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    }).then(res => {
      if (res.data.exists) {
        setAnlageId(res.data.id);
      }
    });
  }, [formData.projektNummer, id]); // ✅ add id




  const cardBg = colorMode === "light" ? "white" : "gray.800";
  const borderColor = colorMode === "light" ? "gray.200" : "whiteAlpha.300";
  const titleColor = colorMode === "light" ? "blue.600" : "blue.300";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  // 🟩 Handle Wartung input
  /*const handleWartungChange = (e) => {
    const { name, value, type, checked } = e.target;
    setWartung((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  */

  const validate = () => {
    const newErrors = {};
    fields.forEach(({ key, required }) => {
      if (required && !String(formData[key]).trim()) {
        newErrors[key] = "Dieses Feld ist erforderlich.";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSaveUpdate = async () => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/anlagen/${anlageId}`,
        { ...formData },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      showSuccess("Gespeichert!", "Anlage wurde aktualisiert.");
    } catch {
      showError("Fehler!", "Aktualisierung fehlgeschlagen.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isEditMode) {
      // UPDATE
      try {
        const valueAnlagenGroesse = formData.anlagenGroesse.replace(",", ".");
        await axios.put(
          `${process.env.REACT_APP_API_URL}/api/anlagen/${id}`,
          { ...formData, anlagenGroesse: Number(valueAnlagenGroesse) },
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );
        showSuccess("Gespeichert!", "Anlage aktualisiert.");
        return;
      } catch {
        showError("Fehler!", "Aktualisierung fehlgeschlagen.");
        return;
      }
    }

    if (!validate()) return;
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/anlagen/check/${formData.projektNummer}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );

      if (res.data.exists) {
        showError("Fehler!", "Diese Projekt-Nr. existiert bereits.");
        setLoading(false);
        return;
      }

      // 🟩 Include wartung data in payload
      const payload = { ...formData };
      console.log("Payload being sent:", payload); // ✅ Add here
      const resPost = await axios.post(`${process.env.REACT_APP_API_URL}/api/anlagen`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      showSuccess("Erfolg!", "Anlage erfolgreich erstellt.");
      setAnlageId(resPost.data.id);  // new
      onNext?.();
    } catch {
      showError("Fehler!", "Anlage konnte nicht erstellt werden.");
    } finally {
      setLoading(false);
    }
  };

  /*
    const handleGeneratePdf = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/anlagen/${anlageId}/pdf`,
          {
            responseType: "blob", // important for PDF
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
          }
        );
  
        const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
        window.open(url, "_blank");
      } catch (error) {
        showError("Fehler!", "PDF konnte nicht geladen werden.");
      }
    };
  
    */

  useEffect(() => {
    if (!id) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/anlagen/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        const a = res.data;

        setFormData({
          projektNummer: a.projektNummer ?? "",
          anlagenName: a.anlagenName ?? "",
          anlagenGroesse: a.anlagenGroesse ?? "",
          strasse: a.strasse ?? "",
          plz: a.plz ?? "",
          ort: a.ort ?? "",
          latitude: a.latitude ?? "",
          longitude: a.longitude ?? "",
        });

        //setWartung(a.wartung ?? {});
        setAnlageId(a.id);
      });
  }, [id]);

  return (
    <Box
      as="form"
      onSubmit={handleSubmit}
      bg={cardBg}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="2xl"
      boxShadow="xl"
      p={{ base: 6, md: 8 }}
      w="100%"
      maxW="7xl"
    >
      <Heading as="h2" fontSize="27px" color={titleColor} mb={12}>
        {isEditMode ? "Anlage bearbeiten" : "Neue Anlage erstellen"}
      </Heading>

      <VStack spacing={6} align="stretch">
        <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={4}>
          {fields.map(({ key, label, required }) => (
            <GridItem key={key}>
              <Box mb={3}>
                <Text fontWeight="semibold" mb={1}>
                  {label} {required && "*"}
                </Text>
                <Input
                  id={key}
                  name={key}
                  value={formData[key]}
                  onChange={handleChange}
                  placeholder={label}
                />
              </Box>
            </GridItem>
          ))}
        </Grid>


        {/* 🟩 Add contact section before submit */}
        {/* ✅ Show KontaktSection only after Anlage created */}
        {anlageId && (
          <>
            <WartungSection selectedAnlageId={anlageId} />
            <KontaktSection anlageId={anlageId} />
            <ModuleSection selectedAnlageId={anlageId} />
            <WechselrichterSection selectedAnlageId={anlageId} />
            <DatenloggerSection selectedAnlageId={anlageId} />
            <MobilfunkRouterSection selectedAnlageId={anlageId} />
            <NetzwerkRouterSection selectedAnlageId={anlageId} />
            <AufstellungsortSection selectedAnlageId={anlageId} />
            <AngabenZumDachSection selectedAnlageId={anlageId} />
            <DacheindeckungSection selectedAnlageId={anlageId} />
            <SchienensystemSection selectedAnlageId={anlageId} />
            <ModulbefestigungSection selectedAnlageId={anlageId} />
            <BefestigungSection selectedAnlageId={anlageId} />
            <BeschwerungSection selectedAnlageId={anlageId} />
            <AusrichtungUndNeigungSection selectedAnlageId={anlageId} />
            <NeigungDerModuleSection selectedAnlageId={anlageId} />
            <ZaehlerSection selectedAnlageId={anlageId} />
          </>
        )}

        <Flex gap={3}>

          {!anlageId && (
            <Flex gap={3}>
              <Button
                mt={10}
                bg="blue.500"
                color="white"
                _hover={{ bg: "blue.600" }}
                fontSize="21px"
                isLoading={loading}
                type="submit"
              >
                Speichern
              </Button>
            </Flex>
          )}

          <Button 
          type="button"
           bg="#235827"
         _hover={{ bg: "#34743b" }}
          fontSize="21px"
          mt={10}
          onClick={() => navigate("/dashboard")}>
            Abschließen
          </Button>

        </Flex>

      </VStack>
    </Box>
  );
}
